"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeTLV = exports.encodeTLV = exports.TLVEntryType = exports.NostrPrefix = void 0;
const utils = __importStar(require("@noble/curves/abstract/utils"));
const base_1 = require("@scure/base");
var NostrPrefix;
(function (NostrPrefix) {
    NostrPrefix["PublicKey"] = "npub";
    NostrPrefix["PrivateKey"] = "nsec";
    NostrPrefix["Note"] = "note";
    // TLV prefixes
    NostrPrefix["Profile"] = "nprofile";
    NostrPrefix["Event"] = "nevent";
    NostrPrefix["Relay"] = "nrelay";
    NostrPrefix["Address"] = "naddr";
})(NostrPrefix = exports.NostrPrefix || (exports.NostrPrefix = {}));
var TLVEntryType;
(function (TLVEntryType) {
    TLVEntryType[TLVEntryType["Special"] = 0] = "Special";
    TLVEntryType[TLVEntryType["Relay"] = 1] = "Relay";
    TLVEntryType[TLVEntryType["Author"] = 2] = "Author";
    TLVEntryType[TLVEntryType["Kind"] = 3] = "Kind";
})(TLVEntryType = exports.TLVEntryType || (exports.TLVEntryType = {}));
function encodeTLV(prefix, id, relays, kind, author) {
    const enc = new TextEncoder();
    const buf = prefix === NostrPrefix.Address ? enc.encode(id) : utils.hexToBytes(id);
    const tl0 = [0, buf.length, ...buf];
    const tl1 = relays
        ?.map(a => {
        const data = enc.encode(a);
        return [1, data.length, ...data];
    })
        .flat() ?? [];
    const tl2 = author ? [2, 32, ...utils.hexToBytes(author)] : [];
    const tl3 = kind ? [3, 4, ...new Uint8Array(new Uint32Array([kind]).buffer).reverse()] : [];
    return base_1.bech32.encode(prefix, base_1.bech32.toWords(new Uint8Array([...tl0, ...tl1, ...tl2, ...tl3])), 1000);
}
exports.encodeTLV = encodeTLV;
function decodeTLV(str) {
    const decoded = base_1.bech32.decode(str, 1000);
    const data = base_1.bech32.fromWords(decoded.words);
    const entries = [];
    let x = 0;
    while (x < data.length) {
        const t = data[x];
        const l = data[x + 1];
        const v = data.slice(x + 2, x + 2 + l);
        entries.push({
            type: t,
            length: l,
            value: decodeTLVEntry(t, decoded.prefix, new Uint8Array(v)),
        });
        x += 2 + l;
    }
    return entries;
}
exports.decodeTLV = decodeTLV;
function decodeTLVEntry(type, prefix, data) {
    switch (type) {
        case TLVEntryType.Special: {
            if (prefix === NostrPrefix.Address) {
                return new TextDecoder("ASCII").decode(data);
            }
            else {
                return utils.bytesToHex(data);
            }
        }
        case TLVEntryType.Author: {
            return utils.bytesToHex(data);
        }
        case TLVEntryType.Kind: {
            return new Uint32Array(new Uint8Array(data.reverse()).buffer)[0];
        }
        case TLVEntryType.Relay: {
            return new TextDecoder("ASCII").decode(data);
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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